var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel',{attrs:{"popout":""}},_vm._l((_vm.registros),function(item,i){return _c('v-expansion-panel-content',{key:i,attrs:{"lazy":""}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(item.name))]),_c('v-card',[_c('v-card-text',[_c('PermisoComponent',{attrs:{"model":item.id,"group":_vm.group}})],1)],1)],1)}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42a6ece7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/models/ModelsLista.vue
// module id = null
// module chunks = 